import React, { useEffect, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import usePageTitle from "../hooks/usePageTitle";
import "./PaymentSuccessPage.css";

function PaymentSuccessPage() {
  const { t } = useTranslation();

  usePageTitle(t("paymentSuccess.pageTitle"));

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    // Redireciona automaticamente após 10 segundos
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/profile");
          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="payment-success-wrapper">
      <div className="success-bg-glow"></div>

      <div className="success-card-premium">
        <div className="icon-box-animated">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>

        <h1>{t("paymentSuccess.title")}</h1>
        <p>{t("paymentSuccess.description")}</p>

        <div className="premium-status-badge">
          <div className="badge-item active">
            <span>{t("paymentSuccess.statusLabel")}</span>
            <span>{t("paymentSuccess.statusValue")}</span>
          </div>
          <div className="badge-sep"></div>
          <div className="badge-item">
            <span>{t("paymentSuccess.deliveryLabel")}</span>
            <span>{t("paymentSuccess.deliveryValue")}</span>
          </div>
        </div>

        <Link to="/profile" className="btn-success-return">
          {t("paymentSuccess.buttonReturn")}
        </Link>

        <div className="redirect-text-small">
          <Trans i18nKey="paymentSuccess.redirectText" count={countdown}>
            Redirecionando para o perfil em <strong>{{ count: countdown }}s</strong>...
          </Trans>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccessPage;
